import React, { useState } from 'react';
import { Row, Button, InlineEditColumnProps, FormInput, InlineEditTable, Widget, MasterDetailForm } from '@digital/ui';
import { TipoProjeto, TPData } from '@app/api/tipoProjeto';
import { Collapse, Icon, Input } from 'antd';
import { hasPermission } from '@app/helpers/permissions';
import PerfectScrollbar from 'react-perfect-scrollbar';

interface TipoProjetoProps {
  titulo: string;
  label: string;
  data: TipoProjeto[];
  handleDelete(id: string): Promise<unknown>;
  handleCreate: (record: Omit<TPData, 'codigo'>) => Promise<TipoProjeto | undefined>;
  handleUpdate: (record: { id: string; nome: string }) => Promise<boolean>;
  shouldUpdate: (needed: boolean) => void;
  isUpdate: boolean;
}

const TipoProjetoComponent = (props: TipoProjetoProps) => {
  const { titulo, label, data, isUpdate, handleCreate, handleUpdate, handleDelete, shouldUpdate } = props;
  const [nome, setNome] = useState<string>('');

  const columns = () => {
    return [
      {
        title: 'Codigo',
        dataIndex: 'data.codigo',
        width: '10%',
      },
      {
        title: 'Nome',
        dataIndex: 'data.nome',
        width: '80%',
        renderEdit: () => <FormInput name="data.nome" disabled={false} required />,
      },
      {
        title: 'Opções',
        render: (item: TipoProjeto) =>
          hasPermission(['ACRONIMOS_DELETAR']) && (
            <>
              <Button
                confirm="Deseja realmente excluir este registro?"
                okText="Confirmar"
                onClick={() => handleDelete(item.id)}
                icon="science-minus"
                style={{ width: 43, margin: 4, textAlign: 'center' }}
              />
            </>
          ),
      },
    ] as InlineEditColumnProps<TipoProjeto>[];
  };

  const { Panel } = Collapse;

  const handleChangeNome = (value: string) => (value.length > 0 ? setNome(value) : setNome(''));

  const handleClick = async () => {
    if (nome) {
      const result = await handleCreate({ nome });
      
      if (result) {
        !isUpdate ? shouldUpdate(true) : shouldUpdate(false);
      }
    }
  };

  return (
    <>
      <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="1" header={titulo} style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[
                hasPermission(['ACRONIMOS_SALVAR', 'ACRONIMOS_EDITAR']) && (
                      <Button icon="commons-ok" name="" title="Salvar" onClick={handleClick} />
                ),
              ]}>
              <Row>
                <InlineEditTable
                  rowKey="id"
                  columns={columns()}
                  updateItem={hasPermission(['ACRONIMOS_EDITAR']) ? handleUpdate : undefined}
                  dataSource={data}
                  pagination={false}
                  disablenotification={false}
                />
              </Row>
              <Row>
                <fieldset>
                  <legend>Inserir Nova Linha</legend>
                  <FormInput
                    name="nome"
                    label="Nome"
                    placeholder={label}
                    title="Nome"
                    onChange={e => (hasPermission(['ACRONIMOS_EDITAR']) ? handleChangeNome(e.target.value) : undefined)}
                    span={3}
                  />
                </fieldset>
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default TipoProjetoComponent;
